import React, { useState } from "react";
import { Button, List, Tooltip, Affix } from "antd";
import { SVGicon } from "../../../styleGuide/SVGicon/SVGicon";
import { Link } from "react-router-dom";
import "./Pricing.css";
import { Helmet } from "react-helmet";

const FreePlans = [
     { planDetails: "Basic Company Info & Mission", },
     { planDetails: "Review Requests & Responses", },
     { planDetails: "Employer Profile Analytics", },
];
const SelectPlans = [
     { selectPlanDetails: "Industry Benchmark Report", },
     { selectPlanDetails: "Affiliated Profiles", },
];

const FeaturesByPlan = [
     { featurePlanFree: true, featurePlanSelect: true, featurePlanDesc: "Basic Company Info & Mission", featurePlanTooltip: "Basic Company Info & Mission", },
     { featurePlanFree: true, featurePlanSelect: true, featurePlanDesc: "Company Logo", featurePlanTooltip: "Company Logo", },
     { featurePlanFree: true, featurePlanSelect: true, featurePlanDesc: "Company Updates", featurePlanTooltip: "Company Updates", },
     { featurePlanFree: true, featurePlanSelect: true, featurePlanDesc: "Review Requests & Responses", featurePlanTooltip: "Review Requests & Responses", },
     { featurePlanFree: true, featurePlanSelect: true, featurePlanDesc: "Promotional Badges", featurePlanTooltip: "Promotional Badges", },
     { featurePlanFree: true, featurePlanSelect: true, featurePlanDesc: "Community Submitted Photos", featurePlanTooltip: "Community Submitted Photos", },
     { featurePlanFree: false, featurePlanSelect: true, featurePlanDesc: "Featured Reviews", featurePlanTooltip: "Featured Reviews", },
     { featurePlanFree: false, featurePlanSelect: true, featurePlanDesc: "Custom Content", featurePlanTooltip: "Custom Content", },
     { featurePlanFree: false, featurePlanSelect: false, featurePlanDesc: "Affiliated Profiles", featurePlanTooltip: "Affiliated Profiles", },
];
const FeaturesByPlanListen = [
     { featurePlanFree: true, featurePlanSelect: true, featurePlanDesc: "Employer Profile Activity", featurePlanTooltip: "Employer Profile Activity", },
     { featurePlanFree: true, featurePlanSelect: true, featurePlanDesc: "Candidate Demographics", featurePlanTooltip: "Candidate Demographics", },
     { featurePlanFree: true, featurePlanSelect: true, featurePlanDesc: "Rating & Interview Trends", featurePlanTooltip: "Rating & Interview Trends", },
     { featurePlanFree: true, featurePlanSelect: true, featurePlanDesc: "Company Update Analytics", featurePlanTooltip: "Company Update Analytics", },
     { featurePlanFree: false, featurePlanSelect: true, featurePlanDesc: "Follower Demographics & Engagement", featurePlanTooltip: "Follower Demographics & Engagement", },
     { featurePlanFree: false, featurePlanSelect: true, featurePlanDesc: "Ratings by Job Title & Location", featurePlanTooltip: "Ratings by Job Title & Location", },
     { featurePlanFree: false, featurePlanSelect: true, featurePlanDesc: "Competitor Comparisons", featurePlanTooltip: "Competitor Comparisons", },
     { featurePlanFree: false, featurePlanSelect: true, featurePlanDesc: "Keyword Analysis of Reviews", featurePlanTooltip: "Keyword Analysis of Reviews", },
     { featurePlanFree: false, featurePlanSelect: true, featurePlanDesc: "Brand Impressions", featurePlanTooltip: "Brand Impressions", },
     { featurePlanFree: false, featurePlanSelect: true, featurePlanDesc: "Industry Benchmark Report", featurePlanTooltip: "Industry Benchmark Report", },
];
const FeaturesBrand = [
     { featurePlanFree: false, featurePlanSelect: true, featurePlanDesc: "The more a candidate sees a company's brand over time the more likely they are to apply. Use Brand Advertising to target the right candidate, with the right message, at the right time." },
];

export const Pricing = () => {
     const [top, setTop] = useState(0);
     return (
          <>
               <Helmet>
                    <title>Features & Pricing | Metropolis</title>
               </Helmet>
               <section className="sector-planPricing-wrap ground-color-ashes">
                    <div className="mtp-container">
                         <div className="section-header-xl ">
                              <h3 className="section-header-xl-primary-heading  text-color-alpha fw-700">
                                   Metropolis Plans & Pricing
                              </h3>
                              <p className="section-header-xl-secondary-text text-color-alpha fw-500">
                                   Our products work together to help meet your employer branding needs.
                              </p>
                         </div>
                         <div className="sector-pricing-wrap">
                              <div className="sector-pricing-content">
                                   <div className="pricing-content-wrap flex-center">
                                        <h4 className=" text-color-alpha fw-700">Free</h4>
                                        <span className=" text-color-alpha fw-500">Find Your Voice</span>
                                        <div className="sector-pricing-divider"></div>
                                        <div className="sector-listing-wrap">
                                             <p className=" text-color-alpha fw-600">Get started with the basic:</p>
                                             <List className="price-list">
                                                  {FreePlans.map((planItems, planIndex) => (
                                                       <List.Item key={planIndex} className=" text-color-alpha fw-500">
                                                            <span className="plans-card-check flex-center flex-auto-0 contain-image">
                                                                 {SVGicon.mtpIconCheckmarkGreen}
                                                            </span>
                                                            <span className="ml-2">{planItems.planDetails}</span>
                                                       </List.Item>
                                                  ))}
                                             </List>
                                        </div>
                                   </div>
                                   <div className="pricing-btn-wrap">
                                        <Link to="/signup" className="pricing-btn fill-btn">
                                             Sign Up
                                        </Link>
                                   </div>
                              </div>
                              <div className="sector-pricing-content">
                                   <div className="pricing-content-wrap flex-center">
                                        <h4 className=" text-color-alpha fw-700">Select</h4>
                                        <span classSelect=" text-color-alpha fw-500">Amplify Your Message</span>
                                        <div className="sector-pricing-divider"></div>
                                        <div className="sector-listing-wrap">
                                             <p className=" text-color-alpha fw-600">Everything in Free & Standard plus:</p>
                                             <List className="price-list">
                                                  {SelectPlans.map((planItems, planIndex) => (
                                                       <List.Item key={planIndex} className=" text-color-alpha fw-500">
                                                            <span className="plans-card-check flex-center flex-auto-0 contain-image">
                                                                 {SVGicon.mtpIconCheckmarkGreen}
                                                            </span>
                                                            <span className="ml-2">{planItems.selectPlanDetails}</span>
                                                       </List.Item>
                                                  ))}
                                             </List>
                                        </div>
                                        <span className="select-content fw-400  text-color-bravo text-center">Select is a branding bundle that gives you access indeed Company Pages Premium.</span>
                                   </div>
                                   <div className="pricing-btn-wrap">
                                        <Link to="/contact" className="pricing-btn transparent-btn">
                                             Contact Sales
                                        </Link>

                                   </div>
                              </div>
                         </div>
                         <div className="compare-wrap flex-center">
                              <span className="fw-500">Compare All Features</span>
                              <div className="compare-card"></div>
                         </div>
                    </div>
               </section>

               <section className="featuresByPlan">
                    <div className="mtp-container">
                         <div className="section-header-lg ">
                              <h3 className="section-header-lg-primary-heading  text-color-alpha fw-700">
                                   All Features by Plan
                              </h3>

                         </div>
                         <div className="featuresPlan-wrap">
                         <Affix offsetTop={top} style={{ width: "100%", overflow: "hidden" }}>
                              <div className="featuresPlan-head-wrap" onScroll={() => setTop(top + 10)}>
                                   <div className="featuresPlan-reach-wrap">
                                        <div className="featuresPlan-icon-wrap flex-center flex-auto-0 contain-image">{SVGicon.mtpIconReach}</div>
                                        <div className="featuresPlan-des">
                                             <h6 className="fw-700">Reach</h6>
                                             <p>Grow awareness</p>
                                        </div>
                                   </div>
                                   <div className="featuresPlan-freeSignUp-wrap text-center">
                                        <h6 className="fw-700">Free</h6>
                                        <span className="featuresPlan-freeSignUp-link text-color-berry fw-500">Sign Up</span>
                                   </div>
                                   <div className="featuresPlan-selectContectSales-wrap text-center">
                                        <h6 className="fw-700">Select</h6>
                                        <span className="featuresPlan-freeSignUp-link text-color-berry fw-500">Contact Sales</span>
                                   </div>
                              </div>
                              </Affix>
                              {FeaturesByPlan.map((featuresplan, featuresplanIndex) => (
                                   <div key={featuresplanIndex} className="featuresPlan-content-wrap ">
                                        <div className="featuresPlan-reach-content-wrap">
                                             <p>{featuresplan.featurePlanDesc}</p>
                                             <Tooltip placement="top" title={featuresplan.featurePlanTooltip}><Button>{SVGicon.mtpIconInformation}</Button></Tooltip>
                                        </div>
                                        <div className="featuresPlan-freeSignUp-content-wrap flex-center">
                                             {featuresplan.featurePlanFree === true ? (<div className="playIcon flex-center flex-auto-0 contain-image">{SVGicon.mtpIconCheckmarkGreen}</div>) : ""}
                                        </div>
                                        <div className="featuresPlan-selectContectSales-content-wrap flex-center">
                                             {featuresplan.featurePlanSelect === true ? (<div className="playIcon flex-center flex-auto-0 contain-image">{SVGicon.mtpIconCheckmarkGreen}</div>) : ""}
                                        </div>
                                   </div>
                              ))}

                              <div className="FeaturesByPlanListen-wrap">
                              <Affix offsetTop={top}>
                                   <div className="featuresPlan-head-wrap" onScroll={() => setTop(top + 10)}>
                                        <div className="featuresPlan-reach-wrap">
                                             <div className="featuresPlan-icon-wrap flex-center flex-auto-0 contain-image">{SVGicon.mtpIconListen}</div>
                                             <div className="featuresPlan-des">
                                                  <h6 className="fw-700">Listen</h6>
                                                  <p>Understand sentiment</p>
                                             </div>
                                        </div>
                                        <div className="featuresPlan-freeSignUp-wrap text-center">
                                             <h6 className="fw-700">Free</h6>
                                             <span className="featuresPlan-freeSignUp-link text-color-berry fw-500">Sign Up</span>
                                        </div>
                                        <div className="featuresPlan-selectContectSales-wrap text-center">
                                             <h6 className="fw-700">Select</h6>
                                             <span className="featuresPlan-freeSignUp-link text-color-berry fw-500">Contact Sales</span>
                                        </div>
                                   </div>
                                   </Affix>
                                   {FeaturesByPlanListen.map((featuresplanListen, featuresplanIndex) => (
                                        <div key={featuresplanIndex} className="featuresPlan-content-wrap ">
                                             <div className="featuresPlan-reach-content-wrap">
                                                  <p>{featuresplanListen.featurePlanDesc}</p>
                                                  <Tooltip placement="top" title={featuresplanListen.featurePlanTooltip}><Button>{SVGicon.mtpIconInformation}</Button></Tooltip>
                                             </div>
                                             <div className="featuresPlan-freeSignUp-content-wrap flex-center">
                                                  {featuresplanListen.featurePlanFree === true ? (<div className="playIcon flex-center flex-auto-0 contain-image">{SVGicon.mtpIconCheckmarkGreen}</div>) : ""}
                                             </div>
                                             <div className="featuresPlan-selectContectSales-content-wrap flex-center">
                                                  {featuresplanListen.featurePlanSelect === true ? (<div className="playIcon flex-center flex-auto-0 contain-image">{SVGicon.mtpIconCheckmarkGreen}</div>) : ""}
                                             </div>
                                        </div>
                                   ))}

                              </div>
                         </div>
                    </div>
               </section>

               <section className="featuresAddOns">
                    <div className="mtp-container">
                         <div className="section-header-lg ">
                              <h3 className="section-header-lg-primary-heading  text-color-alpha fw-700">
                                   Add-Ons
                              </h3>
                              <h6 className="fw-500">These services can be added to your Standard or Select package for an added cost.</h6>
                         </div>
                         <div className="featuresPlan-wrap">
                         <Affix offsetTop={top}>
                              <div className="featuresPlan-head-wrap" onScroll={() => setTop(top + 10)}>
                                   <div className="featuresPlan-reach-wrap">
                                        <div className="featuresPlan-icon-wrap flex-center flex-auto-0 contain-image">{SVGicon.mtpIconBrandAdvertising}</div>
                                        <div className="featuresPlan-des">
                                             <h6 className="fw-700">Brand Advertising</h6>
                                             <p>Target Top Talent</p>
                                        </div>
                                   </div>
                                   <div className="featuresPlan-freeSignUp-wrap text-center">
                                        <h6 className="fw-700">Free</h6>
                                        <span className="featuresPlan-freeSignUp-link text-color-berry fw-500">Sign Up</span>
                                   </div>
                                   <div className="featuresPlan-selectContectSales-wrap text-center">
                                        <h6 className="fw-700">Select</h6>
                                        <span className="featuresPlan-freeSignUp-link text-color-berry fw-500">Contact Sales</span>
                                   </div>
                              </div>
                              </Affix>
                              {FeaturesBrand.map((featuresplanBrand, featuresplanIndex) => (
                                   <div key={featuresplanIndex} className="featuresPlan-content-wrap ">
                                        <div className="featuresPlan-reach-content-wrap">
                                             <p>{featuresplanBrand.featurePlanDesc}</p>
                                        </div>
                                        <div className="featuresPlan-freeSignUp-content-wrap flex-center">
                                             {featuresplanBrand.featurePlanFree === true ? (<div className="playIcon flex-center flex-auto-0 contain-image">{SVGicon.mtpIconCheckmarkGreen}</div>) : ""}
                                        </div>
                                        <div className="featuresPlan-selectContectSales-content-wrap flex-center">
                                             {featuresplanBrand.featurePlanSelect === true ? (<div className="playIcon flex-center flex-auto-0 contain-image">{SVGicon.mtpIconCheckmarkGreen}</div>) : ""}
                                        </div>
                                   </div>
                              ))}


                         </div>
                    </div>
               </section>

               <section className="story-wrap section-header-lg ground-color-prime">
                    <h3 className="section-header-lg-primary-heading text-color-white fw-700">Tell your story. Attract your perfect candidate.</h3>
                    <Link to="/signup" className="pricing-btn">
                         Sign Up
                    </Link>
               </section>
          </>
     )
}